import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function Highlights() {
  const { t } = useTranslation();

  const fadeInUp = {
    initial: { opacity: 0, y: 40 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 },
  };

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div {...fadeInUp} className="text-center mb-20">
          <h2 className="font-futura font-black text-4xl sm:text-5xl text-primary mb-6">
            {t('common:highlights.title')}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Nature */}
          <motion.div
            {...fadeInUp}
            transition={{ delay: 0.1 }}
            className="bg-white rounded-2xl p-10 text-center shadow-lg hover:shadow-xl transition-all duration-300"
          >
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
              <i className="ri-landscape-line text-6xl text-primary"></i>
            </div>
            <h3 className="font-futura font-bold text-xl text-gray-900 mb-4">
              {t('common:highlights.nature.title')}
            </h3>
            <p className="text-gray-600 text-base leading-relaxed">
              {t('common:highlights.nature.description')}
            </p>
          </motion.div>

          {/* Experience */}
          <motion.div
            {...fadeInUp}
            transition={{ delay: 0.2 }}
            className="bg-white rounded-2xl p-10 text-center shadow-lg hover:shadow-xl transition-all duration-300"
          >
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
              <i className="ri-heart-line text-6xl text-primary"></i>
            </div>
            <h3 className="font-futura font-bold text-xl text-gray-900 mb-4">
              {t('common:highlights.experience.title')}
            </h3>
            <p className="text-gray-600 text-base leading-relaxed">
              {t('common:highlights.experience.description')}
            </p>
          </motion.div>

          {/* Organization */}
          <motion.div
            {...fadeInUp}
            transition={{ delay: 0.3 }}
            className="bg-white rounded-2xl p-10 text-center shadow-lg hover:shadow-xl transition-all duration-300"
          >
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
              <i className="ri-team-line text-6xl text-primary"></i>
            </div>
            <h3 className="font-futura font-bold text-xl text-gray-900 mb-4">
              {t('common:highlights.organization.title')}
            </h3>
            <p className="text-gray-600 text-base leading-relaxed">
              {t('common:highlights.organization.description')}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}